<template>
    <div id="main-wrapper" class="dark-theme" @mousemove="onMouseMove">
        <Preloader :backgroundColor="preloaderColor"></Preloader>
        <!-- Navbar -->
        <Navbar></Navbar>

        <!-- Hero Section Dark -->
        <section id="home">
        <HeroSectionDark
            v-bind:name="name"
            v-bind:title="title"
            v-bind:imgProfile="imgProfile"
            v-bind:cvUrl="cvUrl"
            v-bind:mainTechs="mainTechs">
        </HeroSectionDark>
        </section>

        <!-- About Me Dark -->
        <section id="about">
        <AboutMeEnhanced
            v-bind:description="description"
            v-bind:education="education.list"
            v-bind:metrics="metrics">
        </AboutMeEnhanced>
        </section>

        <!-- Services Section -->
        <section id="services">
        <SectionWrapperDark
            v-bind:title="specialities.title">
            <div class="services-grid">
                <ServiceCard
                    v-for="item in specialities.list"
                    v-bind:icon="item.icon"
                    v-bind:title="item.title"
                    v-bind:description="item.description"
                    v-bind:key="item.id">
                </ServiceCard>
            </div>
        </SectionWrapperDark>
        </section>
        <!-- Services Section -->

        <!-- Work Experience Section -->
        <section id="experience">
        <SectionWrapperDark
            v-bind:title="workExperience.title">
                <TimeLineVertical>
                    <TimeLineItemVertical
                        v-for="(item, index) in workExperience.list"
                        v-bind:date="item.date"
                        v-bind:title="item.role"
                        v-bind:description="item.description"
                        v-bind:location="item.location"
                        v-bind:cls="item.cls"
                        v-bind:achievements="item.achievements"
                        v-bind:position="index % 2 === 0 ? 'left' : 'right'"
                        v-bind:key="item.id">
                    </TimeLineItemVertical>
                </TimeLineVertical>
        </SectionWrapperDark>
        </section>
        <!-- Work Experience Section -->

        <!-- .skill-wrapper -->
        <!-- Skills Section -->
        <section id="skills">
        <SectionWrapperDark
            v-bind:title="skill.title">
                <TechSkills :skills="skill.list" />
        </SectionWrapperDark>
        </section>
        <!-- .skill-wrapper -->

        <!-- .portfolio -->
         <section id="enterprise_projects">
        <SectionWrapperDark
            v-bind:title="portfolio.title">
            <ProjectsCarousel :projects="portfolio.list" />
        </SectionWrapperDark>
        </section>
        <!-- .portfolio -->

        <!-- Projects Section -->
        <section id="projects">
        <SectionWrapperDark
            v-bind:title="personalProjects.title">
            <div class="projects-grid">
                <PersonalProject
                    v-for="item in personalProjects.list"
                    v-bind:url="item.url"
                    v-bind:title="item.title"
                    v-bind:description="item.description"
                    v-bind:icon="item.icon"
                    v-bind:image="item.image"
                    v-bind:technologies="item.technologies"
                    v-bind:key="item.id">
                </PersonalProject>
            </div>
        </SectionWrapperDark>
        </section>

        <!-- Contact Section -->
        <section id="contact">
            <SectionWrapperDark title="Contacto">
                <div class="contact-layout">
                    <div class="contact-info">
                        <p class="contact-intro">
                            ¿Tienes un proyecto en mente? ¡Hablemos!
                        </p>
                        <div class="contact-card">
                            <h4>Redes</h4>
                            <a
                                v-for="network in networks"
                                :key="network.id"
                                :href="network.url"
                                target="_blank"
                                rel="noopener"
                                class="contact-link">
                                <i :class="network.clss"></i> {{ network.name }}
                            </a>
                        </div>
                        <div class="contact-card" v-if="cvUrl">
                            <h4>Currículum</h4>
                            <a :href="cvUrl" class="contact-link" download="cv-oscar-sanchez.pdf">
                                <i class="fa fa-download"></i> Descargar CV
                            </a>
                        </div>
                    </div>

                    <form class="contact-card contact-form" @submit.prevent="sendMessage">
                        <input type="hidden" name="form-name" value="contact">
                        <p hidden><input name="bot-field" v-model="form['bot-field']"></p>
                        <div class="form-row">
                            <label>
                                Nombre
                                <input v-model="form.name" name="name" type="text" placeholder="Tu nombre" required>
                            </label>
                            <label>
                                Email
                                <input v-model="form.email" name="email" type="email" placeholder="tu@email.com" required>
                            </label>
                        </div>
                        <label>
                            Asunto
                            <input v-model="form.subject" name="subject" type="text" placeholder="¿De qué se trata?">
                        </label>
                        <label>
                            Mensaje
                            <textarea v-model="form.message" name="message" rows="4" placeholder="Cuéntame más..." required></textarea>
                        </label>
                        <button type="submit" class="form-submit" :disabled="formStatus === 'sending'">
                            <i class="fa fa-paper-plane"></i>
                            {{ formStatus === 'sending' ? 'Enviando...' : 'Enviar mensaje' }}
                        </button>
                        <p v-if="formStatus === 'sent'" class="form-feedback success">¡Gracias! Te responderé pronto.</p>
                        <p v-if="formStatus === 'error'" class="form-feedback error">No se pudo enviar. Inténtalo de nuevo o escríbeme por LinkedIn.</p>
                    </form>
                </div>
            </SectionWrapperDark>
        </section>
    </div>
</template>

<script>
import Navbar from '../components/Navbar'
import HeroSectionDark from '../components/HeroSectionDark'
import AboutMeEnhanced from '../components/AboutMeEnhanced'
import ServiceCard from '../components/ServiceCard'
import PersonalProject from '../components/PersonalProject'
import ProjectsCarousel from '../components/ProjectsCarousel'
import Preloader from '../../../components/Preloader'
import TechSkills from '../components/TechSkills'
import SectionWrapperDark from '../components/SectionWrapperDark'
import TimeLineVertical from '../components/TimeLineVertical'
import TimeLineItemVertical from '../components/TimeLineItemVertical'
import data  from '../../../app.json'

export default {
    name: 'Home',
    components: {
        Navbar,
        HeroSectionDark,
        AboutMeEnhanced,
        ServiceCard,
        PersonalProject,
        ProjectsCarousel,
        Preloader,
        TechSkills,
        SectionWrapperDark,
        TimeLineVertical,
        TimeLineItemVertical
    },

    data() {
        return {
        ...data,
        form: { name: '', email: '', subject: '', message: '', 'bot-field': '' },
        formStatus: null, // null | 'sending' | 'sent' | 'error'
        preloaderColor: '#1a1d29', // Color de fondo del preloader
        }
    },

    methods: {
        onMouseMove(e) {
            this.$el.style.setProperty('--mx', e.clientX + 'px');
            this.$el.style.setProperty('--my', e.clientY + 'px');
        },
        async sendMessage() {
            this.formStatus = 'sending';
            try {
                const res = await fetch('/', {
                    method: 'POST',
                    headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
                    body: new URLSearchParams({ 'form-name': 'contact', ...this.form }).toString()
                });
                if (!res.ok) throw new Error(res.status);
                this.formStatus = 'sent';
                this.form = { name: '', email: '', subject: '', message: '', 'bot-field': '' };
            } catch (err) {
                console.error('Error al enviar formulario:', err);
                this.formStatus = 'error';
            }
        }
    }
}
</script>

<style>
#main-wrapper.dark-theme {
    background: #1a1d29;
    position: relative;
    --dots: radial-gradient(circle, currentColor 1px, transparent 1.5px) 0 0 / 24px 24px;
}

/* Fondo de puntos: capa tenue fija + capa iluminada que sigue al cursor */
#main-wrapper.dark-theme::before,
#main-wrapper.dark-theme::after {
    content: '';
    position: fixed;
    inset: 0;
    pointer-events: none;
    z-index: 0;
    background: var(--dots);
}

#main-wrapper.dark-theme::before {
    color: rgba(255, 255, 255, 0.07);
}

#main-wrapper.dark-theme::after {
    color: rgba(255, 107, 107, 0.6);
    -webkit-mask-image: radial-gradient(160px circle at var(--mx, -999px) var(--my, -999px), #000, transparent);
    mask-image: radial-gradient(160px circle at var(--mx, -999px) var(--my, -999px), #000, transparent);
}

#main-wrapper.dark-theme > section {
    position: relative;
    z-index: 1;
}

body {
    padding-top: 0;
    margin: 0;
}

.services-grid,
.projects-grid {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
    gap: 30px;
    padding: 20px 0;
}

/* Contact Section */
.contact-layout {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 50px;
    align-items: start;
}

.contact-info {
    display: flex;
    flex-direction: column;
    gap: 25px;
}

.contact-intro {
    color: rgba(255, 255, 255, 0.7);
    font-size: 18px;
    line-height: 1.6;
    margin: 0;
}

.contact-card {
    background: #1a1d29;
    border: 1px solid rgba(255, 255, 255, 0.08);
    border-radius: 16px;
    padding: 25px 28px;
}

.contact-card h4 {
    color: #fff;
    font-size: 15px;
    font-weight: 600;
    margin: 0 0 12px 0;
}

.contact-link {
    display: flex;
    align-items: center;
    gap: 12px;
    padding: 6px 0;
    color: rgba(255, 255, 255, 0.6);
    font-size: 15px;
    text-decoration: none;
    transition: color 0.3s ease;
}

.contact-link i {
    width: 18px;
    text-align: center;
}

.contact-link:hover {
    color: #ff6b6b;
}

/* Formulario de contacto */
.contact-form {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.contact-form .form-row {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 20px;
}

.contact-form label {
    display: flex;
    flex-direction: column;
    gap: 8px;
    margin: 0;
    color: #fff;
    font-size: 15px;
    font-weight: 500;
}

.contact-form input,
.contact-form textarea {
    width: 100%;
    box-sizing: border-box;
    background: #212430;
    border: 1px solid rgba(255, 255, 255, 0.1);
    border-radius: 10px;
    padding: 11px 14px;
    color: #fff;
    font-size: 15px;
    font-weight: 400;
    font-family: inherit;
    transition: border-color 0.3s ease;
}

.contact-form textarea {
    resize: vertical;
}

.contact-form input::placeholder,
.contact-form textarea::placeholder {
    color: rgba(255, 255, 255, 0.35);
}

.contact-form input:focus,
.contact-form textarea:focus {
    outline: none;
    border-color: rgba(255, 107, 107, 0.6);
}

.form-submit {
    align-self: flex-start;
    display: inline-flex;
    align-items: center;
    gap: 10px;
    background: #ff6b6b;
    color: #fff;
    border: none;
    border-radius: 10px;
    padding: 11px 24px;
    font-size: 15px;
    font-weight: 600;
    cursor: pointer;
    transition: all 0.3s ease;
}

.form-submit:hover:not(:disabled) {
    background: #ff5252;
    transform: translateY(-2px);
}

.form-submit:disabled {
    cursor: wait;
    background: #8d444a;
}

.form-feedback {
    margin: 0;
}

.form-feedback.success {
    color: #22c55e;
}

.form-feedback.error {
    color: #ff6b6b;
}

@media (max-width: 768px) {
    .projects-grid {
        grid-template-columns: 1fr;
        gap: 20px;
    }

    /* Servicios: carrusel horizontal deslizable */
    .services-grid {
        display: flex;
        gap: 16px;
        padding-bottom: 15px;
        overflow-x: auto;
        scroll-snap-type: x mandatory;
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 107, 107, 0.4) transparent;
    }

    .services-grid > * {
        flex: 0 0 85%;
        scroll-snap-align: start;
    }

    .contact-layout,
    .contact-form .form-row {
        grid-template-columns: 1fr;
        gap: 25px;
    }

    .contact-card {
        padding: 20px;
    }

    /* Orden en móvil: pregunta, formulario, tarjetas */
    .contact-info {
        display: contents;
    }

    .contact-intro {
        order: -2;
    }

    .contact-form {
        order: -1;
    }
}
</style>
